import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import Icon from 'discada/dist/Icon'
import get from 'lodash/get'

import {
  Field,
  SimpleTextField,
  TextField,
  SelectField,
} from 'discada/dist/Form'
import { validators } from 'discada/dist/Form/Field'
import Button from 'discada/dist/Button'

import {
  getRooftopName,
  getTheme,
  getTaggedCustomerFromState,
} from 'selectors/appStatusSelectors'
import { tagSalesLead } from 'actions/naughtyActions'

import { removeFromPageState } from 'actions/pageStateActions'
import { OEM_THEME_OPTIONS, GENERIC_THEME_OPTIONS } from 'utils'

import './SalesLeadForm.scss'

const HOWS = [
  '',
  'Another dealer told me I could whack my competition with this',
  "DealerRefresh, because I'm smart",
  "Driven Data, because I'm really smart",
  'Facebook, and yes I look at it at work',
  'LinkedIn, the only place where stalking is OK',
  'Other',
  "I'm not sure... this is an out-of-body experience for me",
]

const REQUIRED_FIELDS = ['firstName', 'lastName', 'email']

export class SalesLeadForm extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      lead: {
        rooftopName: this.props.oldName,
        theme: this.props.oldTheme,
      },
      loaded: false,
    }
  }

  onChange(field) {
    return ({ target }) =>
      this.setState({ lead: { ...this.state.lead, [field]: target.value } })
  }

  onSubmit() {
    this.props.tagSalesLead(this.state.lead)
    this.props.removeFromPageState(['customizeDemo', 'quoteAction'])
    this.props.onSave && this.props.onSave()
  }

  static getDerivedStateFromProps(newProps, oldState) {
    return {
      loaded: true,
      lead: {
        rooftopName: newProps.oldName,
        theme: newProps.oldTheme,
        ...(!oldState.loaded ? newProps.existingLead : oldState.lead),
      },
    }
  }

  render() {
    let { lead } = this.state,
      { existingLead, showContactFields } = this.props,
      leadComplete =
        REQUIRED_FIELDS.every(k => !isEmpty(lead[k])) &&
        validators.email(lead.email || '')

    return (
      <div className="sales-lead-form">
        {!showContactFields && (
          <article className={c('message', 'is-success')}>
            <div className="message-body">
              <strong>Thanks {existingLead.firstName}!</strong> We'll connect
              with you later, in the meantime, play around some more!
            </div>
          </article>
        )}

        <div className="theme-fields">
          <TextField
            size="small"
            label={
              <>
                <Icon icon="asterisk" /> Name Your Store
              </>
            }
            value={lead.rooftopName}
            onChange={this.onChange('rooftopName')}
          />
          <SelectField
            size="small"
            label="Choose Your Store's Colors"
            value={lead.theme}
            optionGroups={{
              'Manufacturer Themes (More on the way!)': OEM_THEME_OPTIONS,
              'General Themes': GENERIC_THEME_OPTIONS,
            }}
            onChange={this.onChange('theme')}
          />
        </div>

        {showContactFields && (
          <div className="contact-fields">
            <Field
              className="name-fields"
              size="small"
              label={
                <>
                  <Icon icon="asterisk" /> Your Name
                </>
              }
            >
              {fieldProps => (
                <>
                  <div className="field">
                    <SimpleTextField
                      {...fieldProps}
                      placeholder="First Name"
                      leftIcon="user"
                      value={lead.firstName}
                      onChange={this.onChange('firstName')}
                    />
                  </div>
                  <div className="field">
                    <SimpleTextField
                      {...fieldProps}
                      placeholder="Last Name"
                      leftIcon="user"
                      value={lead.lastName}
                      onChange={this.onChange('lastName')}
                    />
                  </div>
                </>
              )}
            </Field>

            <TextField
              size="small"
              leftIcon="envelope"
              label={
                <>
                  <Icon icon="asterisk" /> Email Address
                </>
              }
              value={lead.email}
              onChange={this.onChange('email')}
              validateFor="email"
            />
            <TextField
              size="small"
              leftIcon="phone"
              label="Phone Number"
              value={lead.phone}
              onChange={this.onChange('phone')}
              validateFor="phone"
            />
            <TextField
              size="small"
              leftIcon="briefcase"
              label="Your Title"
              value={lead.role}
              onChange={this.onChange('role')}
            />
            <SelectField
              size="small"
              leftIcon="ear"
              label="How'd you hear about us?"
              value={lead.how}
              options={HOWS.reduce((r, k) => ({ ...r, [k]: k }), {})}
              onChange={this.onChange('how')}
            />
          </div>
        )}
        <Field className="submit">
          <Button
            size="small"
            success
            disabled={!leadComplete}
            onClick={this.onSubmit.bind(this)}
            icon="hand-point-right"
          >
            Let's Go
          </Button>
        </Field>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let existingLead = getTaggedCustomerFromState(state)

  return {
    ...op,
    existingLead,
    oldName: getRooftopName(state),
    oldTheme: getTheme(state),
    showContactFields: !!!get(existingLead, 'firstName'),
  }
}

export default connect(
  mapStateToProps,
  { tagSalesLead, removeFromPageState },
)(SalesLeadForm)
